<template>
  <b-dropdown-item
    v-bind="{ ...$props, ...$attrs }"
    @click="$emit('click', $event)"
  >
    <div class="d-flex flex-row align-items-center py-1">
      <div v-if="icon" class="mr-3">
        <font-awesome-icon class="dropdown-item-icon" :icon="icon" />
      </div>
      <span><slot /></span>
    </div>
  </b-dropdown-item>
</template>

<script>
import { props as BDropdownItemProps } from 'bootstrap-vue/src/components/dropdown/dropdown-item';

export default {
  props: {
    ...BDropdownItemProps,
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item-icon {
  color: $color-navy-blue-60;
}
</style>
